export default __webpack_public_path__ + "static/media/inspect-prouct-hero-1.88fef09a.png";